import React from 'react';
import { MousePointer, Zap, Activity } from 'lucide-react';

const ClicksTab = ({ topProjects, events, formatDate }) => {
  const maxProjectClicks = Math.max(...(topProjects?.map((p) => p.count) || [1]), 1);

  return (
    <div className="tab-pane clicks-pane">
      <div className="overview-grid-2col">
        {/* Top Clicked Projects */}
        <div className="cyber-panel">
          <div className="panel-header">
            <div className="panel-title-group">
              <Zap className="panel-icon cyan" />
              <h3>MOST CLICKED PROJECTS &amp; NODES</h3>
            </div>
            <span className="panel-sub-tag">PROJECT ENGAGEMENT</span>
          </div>

          <div className="panel-body">
            {topProjects.length === 0 ? (
              <div className="empty-state">No project click events recorded yet.</div>
            ) : (
              <div className="rank-list">
                {topProjects.map((proj, idx) => {
                  const percent = Math.round((proj.count / maxProjectClicks) * 100);

                  return (
                    <div key={idx} className="rank-item">
                      <div className="rank-left">
                        <span className="rank-badge">#{idx + 1}</span>
                        <span className="rank-name">{proj._id}</span>
                      </div>
                      <div className="rank-right">
                        <div className="rank-progress-bar">
                          <div
                            className="rank-progress-fill cyan"
                            style={{ width: `${percent}%` }}
                          ></div>
                        </div>
                        <span className="rank-count cyan">{proj.count} clicks</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* Live Interaction Event Log */}
        <div className="cyber-panel">
          <div className="panel-header">
            <div className="panel-title-group">
              <Activity className="panel-icon purple" />
              <h3>REAL-TIME INTERACTION EVENT STREAM</h3>
            </div>
            <span className="panel-sub-tag">LAST 30 EVENTS</span>
          </div>

          <div className="panel-body">
            {events.length === 0 ? (
              <div className="empty-state">No telemetry events logged yet.</div>
            ) : (
              <div className="event-stream-list">
                {events.map((ev, idx) => (
                  <div key={idx} className="event-stream-item">
                    <div className="event-type-badge">{ev.category || 'button_click'}</div>
                    <div className="event-label">{ev.label || ev.event || 'Interaction'}</div>
                    <div className="event-time">{formatDate(ev.timestamp || ev.createdAt)}</div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClicksTab;
